import { ProcessingOverlay } from '@components'

import {
  BorderRadius,
  Color,
  Flex,
  FormItemsGroup,
  Icon,
  Input,
  InputPassword,
  Link,
  SectionMessage,
  Spacing,
  Text,
  Tooltip,
} from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useScoutConnectionImapForm } from '../../contexts/scoutConnectionImapFormContext'

export const ModalBody = (): ReactElement => {
  const { t } = useTranslation()
  const { isProcessing, scoutConnectionImapForm, submitForm } = useScoutConnectionImapForm()

  const {
    FormItem,
    formState: { errors },
  } = scoutConnectionImapForm

  return (
    <Flex flexDirection="column" gap={Spacing.S16}>
      {isProcessing && <ProcessingOverlay color={Color.White} borderRadius={BorderRadius.R16} withAnimation />}
      <SectionMessage variant="neutral">
        <Flex alignItems="center" gap={Spacing.S6}>
          <Text>{t('scout.connection.imap.modal.message')}</Text>
          <Link target="_blank" href="https://www.billy.dk/support/article/forsta-hvordan-imap-fungerer">
            <Text>{t('scout.connection.imap.modal.linkText')}</Text>
          </Link>
        </Flex>
      </SectionMessage>
      <FormItemsGroup>
        <FormItem
          label={t('scout.connection.imap.modal.input.email_address')}
          name="email"
          render={({ field }) => (
            <Input
              {...field}
              placeholder={t('scout.connection.imap.modal.input.email_address.placeholder')}
              onPressEnter={submitForm}
            />
          )}
        />
        <FormItem
          label={t('scout.connection.imap.modal.input.password')}
          name="password"
          render={({ field }) => <InputPassword {...field} onPressEnter={submitForm} />}
        />
        <FormItem
          label={t('scout.connection.imap.modal.input.host')}
          name="host"
          render={({ field }) => (
            <Input
              {...field}
              placeholder={t('scout.connection.imap.modal.input.host.placeholder')}
              onPressEnter={submitForm}
              suffix={
                <Tooltip label={t('scout.connection.imap.modal.input.host.description')} placement="bottom">
                  <Icon icon="info" />
                </Tooltip>
              }
            />
          )}
        />
        <FormItem
          label={t('scout.connection.imap.modal.input.port')}
          name="port"
          render={({ field }) => (
            <Input
              {...field}
              placeholder={t('scout.connection.imap.modal.input.port.placeholder')}
              onPressEnter={submitForm}
              suffix={
                <Tooltip label={t('scout.connection.imap.modal.input.port.description')} placement="bottom">
                  <Icon icon="info" />
                </Tooltip>
              }
              type="number"
            />
          )}
        />
      </FormItemsGroup>
      {errors.root?.connectErrorMessage?.message && (
        <Flex alignItems="center" gap={Spacing.S8}>
          <Icon color={Color.Red700} icon="circleAlert" />
          <Text colorVariant="danger">{errors.root.connectErrorMessage.message}</Text>
        </Flex>
      )}
    </Flex>
  )
}
